<template>
  <div class="container" v-if="isShowPage">
    <Header v-if="isHeader"  @updateWholePage="updateWholePage"></Header>
    <div class="container-wrapper" :class="isMobileFlg?'mobile_wrap':''" id="container-wrapper">
      <keep-alive>
        <router-view v-if="$route.meta.isKeepAlive" :key='$route.fullPath'></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.isKeepAlive" :key='$route.fullPath'></router-view>
    </div>
    <Footer v-if="isFooter && !isMobileFlg"></Footer>
  </div>
</template>

<script>
import Header from "@/components/base//Header";
import Footer from "@/components/base//Footer";
import axios from "axios";
import { BASE_CONFIG } from "@/config/config.js";
export default {
  components: { Header, Footer },
  data() {
    return {
      isIE: false,
      isHeader: true,
      isFooter: true,
      isShowPage: false,
      isMobileFlg:false
    };
  },
  watch: {
    $route(val) {
      console.log("1111", val)
      // 是否做头部、底部的隐藏
      if (["Disclaimer","Login","ConfigInfo"].includes(val.name) || window.location.origin === BASE_CONFIG.OFFICIAL_CONFIG_URL_ORIGIN) {
        this.isHeader = false;
        this.isFooter = false;
      } else {
        this.isHeader = true;
        this.isFooter = true;
      }
    }
  },
  created() {
    if(this.$isMobileDevice()){
      this.isMobileFlg=true;
    }
    this.initUser();
  },
  methods: {
    // 获取登录状态、设置用户信息
    initUser() {
      let userInfo = sessionStorage.getItem("user");
      if (userInfo) {
        this.$store.commit("setUserInfo", JSON.parse(userInfo));
      }
    },
    // 根据sessionStorage 设置 localStorage
    setLocalStorageBySeeeionStorage() {
      this.$removeRootLocalStorage("user");
      const userInfo = this.$getRootScope("user");
      if (userInfo !== "null") {
        this.$setRootLocalStorage("user", userInfo);
      }
    },
    // 获取全局静态资源
    getAllStaticResource(isGetData) {
      return new Promise((resolve, reject) => {
        axios.get(this.$baseStaticUrl + "/projectResource.json?time=" + new Date().getTime()).then(res => {
        // axios.get("./static/projectResource.json?time=" + new Date().getTime()).then(res => {
          console.log("res", res);
          if (res.status === 200) {
            const baseConfigInfo = res.data;
            resolve(baseConfigInfo);
            localStorage.setItem("baseConfigInfo", JSON.stringify(baseConfigInfo));
            if (!isGetData) this.isShowPage = true;
          }
        })
      })
    },
    // 更新全局页面
    updateWholePage(refresh) {
      if (refresh) {
        this.isShowPage = false;
        this.$nextTick(() => {
          this.isShowPage = true;
        })
      }
    }
  },
  mounted() {
    this.getAllStaticResource();
    this.isIE = this.$isIE();
    this.setLocalStorageBySeeeionStorage();

  },
  destroyed() { }
};
</script>

<style>
@import "../assets/style.css";
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue